export default __webpack_public_path__ + "static/media/cisco.9d9d5de3.png";